import { ManageCarrier } from './ManageCarrier.component';
import AddUpsCarrier from './UPS/AddUpsCarrier.component';
import AddFedExAccount from './FedEx/AddFedExAccount.component';
import AddDhlxAccount from './DHLx/AddDhlxAccount.component';
import Util from './Util';

export default { ManageCarrier, AddUpsCarrier, AddFedExAccount, AddDhlxAccount, Util };
